import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { BillingDataService } from '../_services/data-services/billing-data.service';

@Injectable()
export class AchGuestPaymentGuard implements CanActivate {
  constructor(
    private router: Router,
    private billingDataService: BillingDataService
  ) {}

  public canActivate() {
    // If the user goes to the page with out an email paramater or an observable
    // then redirect the user to the login screen
    return this.billingDataService.$billingDetails.pipe(
      map((billingData) => {
        if (!billingData) {
          this.router.navigate(['/make-payment']);
          return false;
        } else {
          return true;
        }
      })
    );
  }
}
